import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { NotificationManager } from 'react-notifications';
import { isMobile } from 'react-device-detect';
import {
  Stack,
  Typography,
  Card,
  Button,
  TextField,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Alert
} from '@mui/material';

import InputMask from 'react-input-mask';

import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import configAxios from '../../../../services/configAxios';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';

import { useSelector } from 'react-redux';
import { selectLogin } from '../../../../store/login/loginSlice';

import useWebSocket from 'react-use-websocket';
import palette from 'src/@core/theme/palette';

const addEditCompetency = (props) => {
  const navigation = useNavigate();
  const location = useLocation();
  const { state, pathname } = location;
  const pathNameSplice = pathname.split('/');
  const [infosCompetency, setInfosCompetency] = useState(state ? { ...state.infosEdit } : {});
  const [infosInicialCompetency] = useState(state ? { ...state.infosEdit } : {});

  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });

  useEffect(() => {
    if (state === null && pathNameSplice[2] === 'editCompetency') [navigation('/app/competency')];
  }, []);

  function HandleInputChange(event) {
    setInfosCompetency({ ...infosCompetency, [event.target.name]: event.target.value });
  }

  function HandleSubmit(event) {
    event.preventDefault();

    if (infoState.id_type_user === 2) {
      infosCompetency.coduser = infoState.coduser;
    }

    if (infosCompetency.id) {
      infosCompetency.id_type_user = infoState.id_type_user;
      infosCompetency.originalStatus = infosInicialCompetency.status;
    }

    infosCompetency.infoState = infoState;

    let router = infosCompetency.id ? '/competency/updateComptency' : '/competency/addCompetency';

    configAxios
      .post(router, infosCompetency)
      .then((response) => {
        if (response.status === 202) {
          NotificationManager.warning('Competência já cadastrada, tente novamente!', 'Atenção');
          return;
        }

        const message = infosCompetency.id
          ? 'Competência atualizada com sucesso!'
          : 'Competência inserida com sucesso!';

        if (infosCompetency.id) {
          if (infosInicialCompetency.status !== infosCompetency.status) {
            sendMessage();
          }
        }

        NotificationManager.success(message, 'Sucesso');

        setInfosCompetency({
          ...infosCompetency,
          id: response.data.id
        });

        const nav = infosCompetency.id
          ? `/app/editCompetency/${infosCompetency.id}`
          : `/app/editCompetency/${response.data.id}`;

        navigation(nav, {
          state: {
            infosEdit: {
              ...infosCompetency,
              id: infosCompetency.id ? infosCompetency.id : response.data.id
            }
          }
        });
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  const wsURL =
    process.env.NODE_ENV === 'production'
      ? 'wss://app.ebi-grupo.com.br:3014'
      : 'ws://localhost:3014';

  /** parâmetros para disparar notificação entre administrativo e inspetor */
  let queryParamsAdm = {
    'x-access-token': infoStateTemp.token,
    eventType: 'message',
    direction: 'administrativo'
  };

  /** parâmetros para disparar notificação */
  let queryParams = {
    'x-access-token': infoStateTemp.token,
    eventType: 'message',
    direction: 'inspetor',
    id_user: infosCompetency.id_user
  };

  /** dispara a notificação */
  const { sendMessage } = useWebSocket(wsURL, {
    queryParams: infoState.id_type_user === 2 ? queryParamsAdm : queryParams,
    share: true
  });

  return (
    <RenderPage title="Competências" id="competency">
      <>
        <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
          <Grid container>
            <BreadcrumbsNav {...props} />
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Typography variant="h4" gutterBottom>
                Cadastro de competências
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Utilize as opções abaixo para inserir e editar as competências
              </Typography>
            </Grid>
            {infoState.id_type_user === 2 && infosCompetency.id && (
              <Grid item xs={12}>
                <Alert severity={'info'}>
                  <Typography variant="subtitle2">
                    Atenção: ao alterar o status da competência para encerada. Todos os timeshets em
                    a competência serão automaticamentes alterados para análise.{' '}
                  </Typography>
                </Alert>
              </Grid>
            )}
            {infoState.id_type_user === 1 &&
              infosCompetency.id &&
              infosCompetency.status === 'Encerrada' && (
                <Grid item xs={12}>
                  <Alert severity={'info'}>
                    <Typography variant="subtitle2">
                      Atenção: ao alterar o status da competência para aberta. Todos os timeshets em
                      a competência serão automaticamentes alterados para o status aberto.{' '}
                    </Typography>
                  </Alert>
                </Grid>
              )}
            {infoState.id_type_user === 1 &&
              infosCompetency.id &&
              infosCompetency.status === 'Aprovada' && (
                <Grid item xs={12}>
                  <Alert severity={'warning'}>
                    <Typography variant="subtitle2">
                      Atenção: ao alterar o status da competência para aprovada. Todos os timeshets
                      em análise referentes a competência serão automaticamentes alterados para o
                      status aprovado.{' '}
                    </Typography>
                  </Alert>
                </Grid>
              )}
          </Grid>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            {!isMobile && (
              <Button
                variant="outlined"
                color="error"
                component={RouterLink}
                to="/app/competency"
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            )}
          </Stack>
        </Stack>
        <Card>
          <CustomGrid>
            <form onSubmit={HandleSubmit}>
              <Box
                sx={{
                  width: '100%',
                  mt: 1,
                  border: 1,
                  color: palette.primary.contrastText,
                  borderColor: 'grey.200',
                  p: 2
                }}>
                <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 1, input: { color: palette.primary.contrastText } }}>
                  <Grid item xs={12} md={2.5}>
                    <InputMask
                      mask="99/9999"
                      style={{ color: palette.primary.contrastText }}
                      value={infosCompetency.competency || ''}
                      onChange={(event) => HandleInputChange(event)}
                      disabled={infosCompetency.id ? true : false}>
                      {() => (
                        <TextField
                          style={{ color: palette.primary.contrastText }}
                          name="competency"
                          fullWidth
                          label="Competência"
                          required
                          variant="outlined"
                          disabled={infosCompetency.id ? true : false}
                          size="small"
                        />
                      )}
                    </InputMask>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InputLabel
                      id="label"
                      sx={isMobile ? { mt: 0 } : { fontSize: '13px', mt: -2.2 }}>
                      Status *
                    </InputLabel>
                    <Select
                      style={{ color: palette.primary.contrastText }}
                      name="status"
                      fullWidth
                      size="small"
                      required
                      disabled={
                        infoState.id_type_user === 2 &&
                        (infosCompetency.status === 'Encerrada' ||
                          infosCompetency.status === 'Aprovada')
                          ? true
                          : false
                      }
                      value={infosCompetency.status || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      <MenuItem style={{ color: palette.primary.contrastText }} value={'Aberta'}>
                        Aberta
                      </MenuItem>
                      {infosCompetency.id &&
                        infoState.id_type_user === 2 &&
                        infosCompetency.status === 'Aprovada' && (
                          <MenuItem value={'Aprovada'}>Aprovada</MenuItem>
                        )}
                      {infosCompetency.id && infoState.id_type_user === 1 && (
                        <MenuItem value={'Aprovada'}>Aprovada</MenuItem>
                      )}
                      {infosCompetency.id && <MenuItem value={'Encerrada'}>Encerrada</MenuItem>}
                    </Select>
                  </Grid>
                </Grid>
              </Box>
              <Stack direction="row" justifyContent="end" sx={{ mt: 5 }}>
                <Button
                  type="submit"
                  variant="contained"
                  size="medium"
                  color="success"
                  sx={{ mr: 2 }}
                  // disabled={infoState.id_type_user === 1}
                  startIcon={<Iconify icon="eva:save-fill" />}>
                  {infosCompetency.id ? 'Atualizar' : 'Salvar'}
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  component={RouterLink}
                  to="/app/competency"
                  startIcon={<Iconify icon="eva:close-circle-fill" />}>
                  Cancelar
                </Button>
              </Stack>
            </form>
          </CustomGrid>
        </Card>
      </>
    </RenderPage>
  );
};

export default addEditCompetency;
